<!--
 * @Descripttion:
 * @version:
 * @Author: lfs
 * @Date: 2020年05月28日 09:02:12
-->
<template>
  <div class="tab">
    <ul class='atb-flex '>
      <template v-for="(item, index) in tabList">
        <li
          v-if="!item.isHide"
          @click='clickSlide(index)'
          :class="[tabIndex == index ? 'slide-tab' : '', iconStyle === 'top' ? 'top' : '']"
          class="atb-flex atb-flex-justify-center atb-flex-items-center"
          :key="item.label + Math.random()"
        >{{item.label }}</li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SwiperTab',
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true,
        // spaceBetween: 20,
      },
      tabIndex: '0'
    };
  },
  computed: {},
  props: {
    tabList: {
      default: new Array(),
      type: Array,
    },
    defaultIndex: {
      type: String,
      default: '0'
    },
    iconStyle:{
      type: String,
      default: 'bottom'
    }
  },
  created() {
  },
  mounted() {
    // this.$nextTick(() => {
    //   document.getElementsByClassName('swiper-slide')[0].classList.add('slide-tab');
    // }); //增加类名
  },
  methods: {
    clickSlide(index) {
      // let swiperSlides = document.getElementsByClassName('swiper-slide');
      // swiperSlides.forEach((val) => {
      //   val.classList.remove('slide-tab');
      // });
      // let swiperSlide = document.getElementsByClassName('swiper-slide')[index];
      // swiperSlide.classList.add('slide-tab'); //增加类名
      this.tabIndex = index.toString();
      this.$emit('getCurrent', {index: index, data: this.tabList[index]});
    },

  },
  watch: {
    defaultIndex: {
      handler(val) {
        this.tabIndex = val;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tab {
  ul {
    /*height: 88px;*/
    padding-left: 23px;
  }
  li {
    font-size: 17px;
    color: #859291;
    position: relative;
    margin-right: 40px;
    padding-bottom: 14px;
    cursor: pointer;
    line-height: 1;
    &.slide-tab {
      color: $--color-text-title;
      font-weight: bold;
    }
    &.top{
      padding-bottom: 24px;
    }
    &.slide-tab::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -8px;
      width: 20px;
      height: 4px;
      background: $--color-primary;
      border-radius: 5px;
    }
    &.slide-tab.top::after{
      top: -20px;
    }
  }
}
</style>
